module.exports = __webpack_public_path__ + "assets/group-19.db5bdb7eab09b3680a6347fb304aec11.png";